module.exports = __webpack_public_path__ + "img/homebtn11.5228e60c.png";